import { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next";
import { CheckSquare, Square, SquarePen, Trash2, UserRoundPlus } from "lucide-react";
import { useMenuContext } from "../../context/useMenuContext";
import { useScheduleContext } from "../../context/useScheduleContext";
import { useDateFilters } from "../../../../../../components/shared/filters/DateFilters/context/useDateFilters";
import { usePermissions } from "../../usePermissions";

export const useUnassignedShiftsMenu = ({ openDeleteModal, openAssignModal }: any) => {
    const { t } = useTranslation();
    const { selected, closeMenu } = useMenuContext();
    const { mode } = useDateFilters();
    const { selectedUnassignedEvents, dispatch, ctrlShiftS } = useScheduleContext();
    const { canAssign, canDeleteUnassignedShift: canDelete, canEditUnassignedShift: canEdit } = usePermissions();

    const isSelected = useMemo(() => {
        return !!selectedUnassignedEvents?.find(
            (event: any) => event?.id === selected?.id
        );
    }, [selectedUnassignedEvents, selected?.id]);

    const onSelectChange = useCallback(() => {
        dispatch({ type: "select-unassign-event", payload: { event: selected } });
        if (mode === "month" && !ctrlShiftS) {
            dispatch({ type: "ctrl-shift-s" });
        }
    }, [dispatch, selected, mode, ctrlShiftS]);

    return useMemo(() => [
        {
            icon: isSelected ? CheckSquare : Square,
            label: t("select"),
            onChange: onSelectChange,
            hidden: false,
            disabled: !(canDelete && canEdit)
        },
        {
            icon: SquarePen,
            label: t("edit"),
            onChange: () => {
                dispatch({
                    type: "selected-cell-or-event",
                    payload: { ...selected, isCreating: false }
                });
                closeMenu();
            },
            hidden: false,
            disabled: !canEdit
        },
        {
            icon: UserRoundPlus,
            label: t("assign"),
            onChange: () => {
                openAssignModal(selected);
                closeMenu();
            },
            hidden: false,
            disabled: !canAssign,
        },
        {
            icon: Trash2,
            label: t("delete"),
            onChange: () => {
                openDeleteModal({
                    type: "cell-unassign",
                    event: {
                        id: selected?.id
                    }
                });
                closeMenu();
            },
            hidden: false,
            disabled: !canDelete,
        },
    ], [
        selected,
        isSelected,
        canEdit,
        canDelete,
        canAssign,
        dispatch,
        openAssignModal,
        openDeleteModal,
        onSelectChange,
        closeMenu,
        t
    ]);
}
